import { useMemo } from 'react';
import { useStore } from 'common/store';
import { UseStoreValues } from 'common/types/store';
import { isDashboardDefinition } from 'common/types/summaryDefinitions';
import { getCustomFirmDefinitions } from 'pages/Intelligence/intelligenceNavigation';
import { useOrderedFirmDefinitions } from 'services/hooks/summaryDefinitions';
import { FirmPdfCustomView } from '../PdfExportConfigDialog.types';

interface UseDialogFirmCustomViewsParams {
  enabled: boolean;
}

interface UseDialogFirmCustomViewsResult {
  customViews: FirmPdfCustomView[];
  isLoading: boolean;
}

// The firm's custom summary views, in tab order. The dialog is mounted under different summary
// definition providers (or none), so it reads the firm definitions query directly; it shares the
// provider's cache key. Dashboards are left out: they have no PDF capture target.
export const useDialogFirmCustomViews = ({ enabled }: UseDialogFirmCustomViewsParams): UseDialogFirmCustomViewsResult => {
  const [storeValues] = useStore() as unknown as UseStoreValues;
  const firmId = storeValues.firmInfo?.id;

  const { orderedDefinitions, isLoading } = useOrderedFirmDefinitions({
    firmId: firmId as number,
    enabled: enabled && Boolean(firmId),
  });

  const customViews = useMemo(
    () =>
      getCustomFirmDefinitions(orderedDefinitions)
        .filter(definition => !isDashboardDefinition(definition))
        .map(({ id, name }) => ({ id, name })),
    [orderedDefinitions]
  );

  return { customViews, isLoading: enabled && isLoading };
};
